module.exports = __webpack_public_path__ + "assets/59c67f61ec183d32f0065a4af7d2c340.svg";